module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16vsO1b/images/cover.jpg?1684514755503",
      "alt": "This image is the cover for the book Crush"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("A Teacher's Passion... She'sspent years teaching students English, changing their lives and igniting a love of learning. Her passion for her job is not only fueled by a love of teaching, but a desire to escape a lifetime of personal loneliness. A survivor of sexual assault, she's also mastered the art of \"self-medicating\" and looking for love in all the wrong places. All that changed the day Marley walked into her class. He was just as wounded as she. . . but there were just some lines a teacher didn't cross, especially when she knows the damage that can be caused by lines that are blurred too early. That was then. This is now. Time changes everything? There's nothing young and innocent about Marley now. When she bumps into him many years later, Marley admits the crush he had on her has never gone away. And now that he's a man, he wants to help heal her broken heart.  Can the student she knew become the man she loves? Is it even possible to accept love from such an unseemly source? In her signature vignettes, Nicole Bailey-Williams returns with a riveting story of redemption after ruin and the indomitable nature of love.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nicole Bailey Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Nicole Bailey-Williams is the author of five previous books and many short stories. A Philadelphia native, she lives in New Jersey where she juggles family, mostly from her car, and food at her gourmet popcorn company.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Brown Girls Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0